import ProfileLayout from './layout/ProfileLayout.vue'
import Profile from '@/views/webapp/Profile.vue'

const profileRoutes = [
  {
    path: '/profile',
    component: ProfileLayout,
    children: [
      {
        path: '',
        name: 'Profile',
        component: Profile,
      },
      {
        path: 'voucher',
        name: 'Voucher',
        component: () => import('@/views/webapp/Voucher.vue'),
      },
      {
        path: 'member-card',
        name: 'MemberCard',
        component: () => import('@/views/webapp/Member.vue'),
      },
      {
        path: 'accum',
        name: 'Accum',
        component: () => import('@/views/webapp/Accum.vue'),
      },
      // {
      //   path: 'appointment',
      //   name: 'AppointmentWebapp',
      //   component: () => import('@/views/webapp/Appointment.vue'),
      // },
      {
        path: 'benefit',
        name: 'Benefit',
        component: () => import('@/views/webapp/Benefit.vue'),
      },
      {
        path: 'course',
        name: 'Course',
        component: () => import('@/views/webapp/Course.vue'),
      },
      {
        path: 'setting',
        name: 'Setting',
        component: () => import('@/views/webapp/Setting.vue'),
      },
    ],
  },
]
export default profileRoutes
